/**
 * ユーザー新規登録ページ
 * パスワードアイコン表示切替
 */
$(function () {
  $(".toggle-password").click(function () {
    // iconの切り替え
    $(this).toggleClass("fa-eye fa-eye-slash");
    // 入力フォームの取得
    let input = $(this).parent().prev("input");
    // type切替
    if (input.attr("type") == "password") {
      input.attr("type", "text");
    } else {
      input.attr("type", "password");
    }
  });
});
